import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

// Utils
import { setUnauthorizedToken } from '../../../utils/auth';

// State
import cartApi from '../cart/api';
import { setError } from '../errors/actions';
import { ITEMS_UPDATE } from '../cart/actionTypes';
import * as types from './actionTypes';
import stockApi from './api';

function fetchListStart() {
  return { type: types.FETCH_LIST_REQUEST };
}

function handleModeIsLoadingStockApply(payload) {
  return { type: types.IS_LOADING_STOCK_APPLY, payload };
}

function fetchListDone(payload) {
  return { type: types.FETCH_LIST_SUCCESS, payload };
}

function fetchListFail(payload) {
  return { type: types.FETCH_LIST_FAILURE, payload };
}

export const fetchList = () => {
  return dispatch => {
    dispatch(fetchListStart());

    return stockApi
      .getList()
      .then(data => dispatch(fetchListDone(data)))
      .catch(({ message }) => dispatch(fetchListFail(message)));
  };
};

export const fetchListIfNeeded = () => {
  return (dispatch, getState) => {
    const { isLoading, isLoaded } = getState().stock.list;

    return !isLoading && !isLoaded ? dispatch(fetchList()) : false;
  };
};

//

function applyStockStart() {
  return { type: types.APPLY_STOCK_REQUEST };
}

function applyStockDone(payload) {
  return { type: types.APPLY_STOCK_SUCCESS, payload };
}

function applyStockFail(payload) {
  return { type: types.APPLY_STOCK_FAILURE, payload };
}

function applyStockGifts(payload) {
  return { type: types.APPLY_STOCK_GIFTS, payload };
}

export const setIsStockReapplied = isReapplied => ({
  type: types.SET_STOCK_IS_REAPPLIED,
  payload: isReapplied,
});

export const applyStock = ({ stock_code, gifts = [] }) => {
  return (dispatch, getState) => {
    const { stock, order } = getState();

    const addedGifts = stock?.gifts || [];

    const restaurant_id = order.checkout.currentRestaurant?.id;

    dispatch(applyStockStart());
    return stockApi
      .apply({ stock_code, gifts: [...addedGifts, ...gifts], restaurant_id })
      .then(data => {
        const cart = data.cart || {};
        const selectedGifts = data.details.selected || [];
        const unauthorizedToken = data.cart?.unauthorized_token;

        if (!_isEmpty(selectedGifts)) {
          dispatch(applyStockGifts(selectedGifts));
        }

        if (unauthorizedToken) {
          setUnauthorizedToken(unauthorizedToken);
        }
        dispatch(updateCart(cart));
        return dispatch(applyStockDone(data));
      })
      .catch(({ message }) => dispatch(applyStockFail(message)));
  };
};

export const reapplyStock = ({ stock_code, gifts = [] }) => {
  return (dispatch, getState) => {
    const { isReapplied } = getState().stock;

    if (!isReapplied) {
      dispatch(applyStock({ stock_code, gifts }));
      dispatch(setIsStockReapplied(true));
    }
  };
};

//

//

function applyStockExtraStart() {
  return { type: types.APPLY_STOCK_EXTRA_REQUEST };
}

function applyStockExtraDone(payload) {
  return { type: types.APPLY_STOCK_EXTRA_SUCCESS, payload };
}

function applyStockExtraFail(payload) {
  return { type: types.APPLY_STOCK_EXTRA_FAILURE, payload };
}

export const applyExtraStock = card => {
  return dispatch => {
    dispatch(applyStockExtraStart());

    return stockApi
      .applyExtra(card)
      .then(data => {
        const cart = data.cart || {};
        const unauthorizedToken = cart.unauthorized_token;

        if (unauthorizedToken) {
          setUnauthorizedToken(unauthorizedToken);
        }

        if (data.success !== false) {
          dispatch(setError(data.details?.rewards?.[0]?.message, { type: 'success' }));
        }

        dispatch(updateCart(cart));
        return dispatch(applyStockExtraDone(data));
      })
      .catch(({ message }) => dispatch(applyStockExtraFail(message)));
  };
};

//

function clearStockStart() {
  return { type: types.CLEAR_STOCK_REQUEST };
}

export function clearStockDone() {
  return { type: types.CLEAR_STOCK_SUCCESS };
}

function clearStockFail(payload) {
  return { type: types.CLEAR_STOCK_FAILURE, payload };
}

export const clearStock = () => {
  return dispatch => {
    dispatch(clearStockStart());
    dispatch(setIsStockReapplied(false));

    return stockApi
      .clear()
      .then(data => {
        dispatch(updateCart(data));
        return dispatch(clearStockDone());
      })
      .catch(({ message }) => dispatch(clearStockFail(message)));
  };
};

//

function addToCartStart(goodId, condIdx) {
  return { type: types.ADD_TO_CART_REQUEST, payload: { goodId, condIdx } };
}

function addToCartDone(goodId, condIdx) {
  return { type: types.ADD_TO_CART_SUCCESS, payload: { goodId, condIdx } };
}

function addToCartFail(goodId, condIdx, error) {
  return {
    type: types.ADD_TO_CART_FAILURE,
    payload: { goodId, condIdx, error },
  };
}

/**
 * Добавляем товар из условия в корзину
 *
 * @param {number} goodId id товара
 * @param {number} condIdx индекс условия промокода, из которого берется текущий товар
 * @param {object} params данные товара для отправки на сервер
 * @returns
 */
export const addToCart = (goodId, condIdx, params) => {
  return (dispatch, getState) => {
    const stockCode = _get(getState(), 'stock.data.code');
    dispatch(addToCartStart(goodId, condIdx));

    return cartApi
      .addToCart(params)
      .then(() => {
        dispatch(addToCartDone(goodId, condIdx));
        return dispatch(applyStock({ stock_code: stockCode }));
      })
      .catch(({ message }) => dispatch(addToCartFail(goodId, condIdx, message)));
  };
};

/**
 * Удаляет ингредиент
 *
 * @param {number} goodId id товара
 * @param {number} variationId id вариации
 * @param {number} index индекс условия промокода, из которого берется текущий товар
 * @param {number} ingredientId id ингредиента
 * @param {text} stockRole 'conditions' or 'rewards'
 */
export const removeIngredient = (goodId, variationId, index, ingredientId, stockRole) => ({
  type: types.REMOVE_INGREDIENT,
  payload: { goodId, variationId, index, ingredientId, stockRole },
});

/**
 * Отменяем удаление ингредиентов
 *
 * @param {number} id - id товара
 * @param {number} variationId id вариации
 * @param {number} index индекс условия промокода, из которого берется текущий товар
 * @param {text} stockRole 'conditions' or 'rewards'
 */
export const cancelRemovedIngredients = (goodId, variationId, index, stockRole) => ({
  type: types.CANCEL_REMOVED_INGREDIENTS,
  payload: { goodId, variationId, index, stockRole },
});

function addRewardStart(goodId, rewardIdx) {
  return { type: types.ADD_REWARD_REQUEST, payload: { goodId, rewardIdx } };
}

function addRewardDone(goodId, rewardIdx) {
  return { type: types.ADD_REWARD_SUCCESS, payload: { goodId, rewardIdx } };
}

function addRewardFail(goodId, rewardIdx, error) {
  return {
    type: types.ADD_REWARD_FAILURE,
    payload: { goodId, rewardIdx, error },
  };
}

export const addReward = (goodId, rewardIdx, gifts = [], replaceGift = false) => {
  return (dispatch, getState) => {
    dispatch(handleModeIsLoadingStockApply(true));
    const stockCode = getState().stock.data?.code;
    // Подарки, которые уже добавлены в корзину
    const addedGifts = getState().stock.data?.details?.selected;
    // При повторном запросе необходимо отправить айди ресторана для проверки на стоп листы
    const restaurant_id = getState().order.checkout.currentRestaurant?.id;

    if (!_isEmpty(gifts)) {
      dispatch(applyStockGifts(gifts));
    }

    if (restaurant_id) {
      // ставим флаг что бы не делать лишний запрос на ручку applyStock на маунт checkout страницы
      dispatch(setIsStockReapplied(true));
    }

    let mergeGifts = [];

    if (replaceGift) {
      // Замена в массиве по индексу и вставка в то место gifts
      mergeGifts = addedGifts
        .slice(0, rewardIdx)
        .concat(gifts)
        .concat(addedGifts.slice(rewardIdx + 1));
    } else {
      mergeGifts = [...addedGifts, ...gifts];
    }

    dispatch(addRewardStart(goodId, rewardIdx));

    return stockApi
      .apply({ stock_code: stockCode, gifts: mergeGifts, restaurant_id })
      .then(data => {
        const cart = _get(data, 'cart', {});

        dispatch(addRewardDone(goodId, rewardIdx));
        dispatch(applyStockDone(data));
        return dispatch(updateCart(cart));
      })
      .catch(({ message }) => dispatch(addRewardFail(goodId, rewardIdx, message)))
      .finally(() => {
        dispatch(handleModeIsLoadingStockApply(false));
      });
  };
};

//

function getUnconditionalListStart() {
  return { type: types.GET_UNCONDITIONAL_LIST_REQUEST };
}

function getUnconditionalListDone(payload) {
  return { type: types.GET_UNCONDITIONAL_LIST_SUCCESS, payload };
}

function getUnconditionalListFail(error) {
  return {
    type: types.GET_UNCONDITIONAL_LIST_FAILURE,
    payload: { error },
  };
}

export const getUnconditionalList = () => {
  return dispatch => {
    dispatch(getUnconditionalListStart());

    return stockApi
      .unconditionalList()
      .then(data => dispatch(getUnconditionalListDone(data[0].details)))
      .catch(({ message }) => dispatch(getUnconditionalListFail(message)));
  };
};

export const clearStockErrors = () => {
  return (dispatch, getState) => {
    if (getState().stock.error) {
      return dispatch({ type: types.CLEAR_STOCK_ERRORS_SUCCESS });
    }

    return false;
  };
};

export const updateCart = payload => {
  return { type: ITEMS_UPDATE, payload };
};

export const setAllRewardsInStopList = val => ({
  type: types.SET_ALL_REWARDS_IN_STOPLIST,
  payload: val,
});

export const setAllConditionGoodsInStopList = val => ({
  type: types.SET_ALL_CONDITION_GOODS_IN_STOPLIST,
  payload: val,
});
